import * as Sentry from "@sentry/nextjs";

type ExclusiveEventHintOrCaptureContext = Parameters<typeof Sentry.captureException>[1];
// Outside your hook, so it's shared across uploads
const errorCaptureCache: { [key: string]: number } = {};
const ERROR_CAPTURE_INTERVAL = 60000; // 60 seconds

export function captureSentryExceptionOnce(
  error: unknown,
  options: ExclusiveEventHintOrCaptureContext | undefined
) {
  // Create an error signature. You can customize this to include more context.
  const errorSignature = (error as { message: string }).message;
  const now = Date.now();

  if (
    errorCaptureCache[errorSignature] &&
    now - errorCaptureCache[errorSignature] < ERROR_CAPTURE_INTERVAL
  ) {
    // Skip capturing this error if it's been reported recently
    return;
  }

  errorCaptureCache[errorSignature] = now;
  Sentry.captureException(error, options);
}
